import { render, staticRenderFns } from "./Truck.vue?vue&type=template&id=512f06fe&scoped=true&"
import script from "./Truck.vue?vue&type=script&lang=js&"
export * from "./Truck.vue?vue&type=script&lang=js&"
import style0 from "./Truck.vue?vue&type=style&index=0&id=512f06fe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512f06fe",
  null
  
)

export default component.exports